import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useLocalStorage } from 'usehooks-ts';
import { cn } from '../../lib/classNameHelpers';
import { localStorageKeys } from '../../lib/localstorageKeys';

export const HidePnlBtn = ({ size = 12, className = '' }) => {
  const [hidePnl, setHidePnl] = useLocalStorage(localStorageKeys.hidePnl, false);
  const Icon = hidePnl ? EyeSlashIcon : EyeIcon;

  return (
    <Icon
      role="button"
      className={cn(
        'cursor-pointer text-contentSecondary hover:text-contentPrimary transition-colors',
        className
      )}
      onClick={() => setHidePnl((x) => !x)}
      width={size}
      height={size}
    />
  );
};
